import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-site-screen-shot',
  templateUrl: './site-screen-shot.component.html',
  styleUrls: ['./site-screen-shot.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatCardModule, TranslateModule, MatProgressSpinnerModule],
})
export class SiteScreenShotComponent implements OnInit {
  @Input() screen_shot: string;
  @Input() fallback_iframe: string;

  public hide_iframe = true;
  public iframe_url: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  reveal_iframe(): void {
    this.hide_iframe = false;
  }

  ngOnInit(): void {
    if (!this.fallback_iframe) {
      this.iframe_url = null;
    }
    this.iframe_url = this.sanitizer.bypassSecurityTrustResourceUrl(`https://${this.fallback_iframe}?display=iframe`);
  }
}
